/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  Document, Font, Image, Link, Page, StyleSheet,
  Text, View,
} from '@react-pdf/renderer';
import React from 'react';

import { formatPhoneDotsIntl, formatPhoneNumber, httpsRegex } from 'utils/lib';
import { montserratFont, vidalokaFont } from 'utils/pdf-fonts';

Font.register(vidalokaFont);

Font.register(montserratFont);

const styles = StyleSheet.create({
  page: {
    position: 'relative',
  },
  background: {
    position: 'absolute',
    top: -1, // -1 on all of these to fix off-by-1 errors with the background images
    left: -1,
    right: -1,
    bottom: -1,
  },
  agentInfoContainer: {
    position: 'absolute',
    top: '7.2in',
    left: '1.48in',
    right: 0,
  },
  agentPicture: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '2.2in',
    height: '2.75in',
    objectFit: 'cover',
    borderRadius: '12px',
  },
  teamOrCompanyLogo: {
    position: 'absolute',
    objectFit: 'contain',
    objectPosition: 'center bottom',
  },
  agentInfoText: {
    color: '#f1f0ea',
    position: 'absolute',
    top: '-0.1in',
    left: '2.8in',
  },
  link: {
    color: '#f1f0ea',
    textDecoration: 'none',
  },
});

const AgentInfo = ({ userInfo }: any) => (
  <View style={styles.agentInfoContainer}>
    <Image src={userInfo.agentInfo.agentPictureUrl} style={styles.agentPicture} />

    <View style={styles.agentInfoText}>
      <Text style={{
        fontFamily: 'Vidaloka',
        fontSize: '50px',
        textTransform: 'uppercase',
        marginBottom: '8px',
      }}
      >
        {`${userInfo.firstName} ${userInfo.lastName ?? ''}`}
      </Text>

      <Text style={{
        fontFamily: 'Montserrat',
        fontWeight: 700,
        fontSize: '19px',
        textTransform: 'uppercase',
      }}
      >
        {`Lic. # ${userInfo.agentInfo.agentDreNumber}`}
      </Text>

      <Text style={{
        fontFamily: 'Montserrat',
        fontWeight: 600,
        fontSize: '36px',
        margin: '12px 0',
        letterSpacing: '4px',
      }}
      >
        <Link src={`tel:${formatPhoneNumber(userInfo.agentInfo.marketingPhoneNumber, true)}`} style={styles.link}>
          {formatPhoneDotsIntl(userInfo.agentInfo.marketingPhoneNumber)}
        </Link>
      </Text>

      <Text style={{
        fontFamily: 'Montserrat',
        fontWeight: 400,
        fontSize: '21px',
      }}
      >
        <Link src={`mailto:${userInfo.agentInfo.marketingEmail}`} style={styles.link}>
          {userInfo.agentInfo.marketingEmail}
        </Link>
      </Text>

      {userInfo.agentInfo.website && (
        <Text style={{
          fontFamily: 'Montserrat',
          fontWeight: 400,
          fontSize: '21px',
        }}
        >
          <Link src={userInfo.agentInfo.website} style={styles.link}>
            {userInfo.agentInfo.website.replace(httpsRegex, '')}
          </Link>
        </Text>
      )}
    </View>
  </View>
);

const SevenSignsDocument = ({ name, userInfo }: any) => {
  const teamOrCompanyLogoUrl = userInfo.agentInfo.teamLogoLightUrl
        ?? userInfo.agentInfo.teamLogoUrl
        ?? userInfo.agentInfo.companyLogoLightUrl
        ?? userInfo.agentInfo.companyLogoUrl;

  return (
    <Document title={name} author="Harvist">
      <Page size={{ width: '20in', height: '11.25in' }} style={styles.page}>
        <Image src="/free-resources/seven-signs-its-time/1.png" style={styles.background} />

        <Image
          src={teamOrCompanyLogoUrl}
          style={{
            ...styles.teamOrCompanyLogo,
            top: '1.0in',
            left: '17.15in',
            width: '1.75in',
            height: '1.3in',
          }}
        />
      </Page>

      <Page size={{ width: '20in', height: '11.25in' }} style={styles.page}>
        <Image src="/free-resources/seven-signs-its-time/2.png" style={styles.background} />
      </Page>

      <Page size={{ width: '20in', height: '11.25in' }} style={styles.page}>
        <Image src="/free-resources/seven-signs-its-time/3.png" style={styles.background} />
      </Page>

      <Page size={{ width: '20in', height: '11.25in' }} style={styles.page}>
        <Image src="/free-resources/seven-signs-its-time/4.png" style={styles.background} />
      </Page>

      <Page size={{ width: '20in', height: '11.25in' }} style={styles.page}>
        <Image src="/free-resources/seven-signs-its-time/5.png" style={styles.background} />
      </Page>

      <Page size={{ width: '20in', height: '11.25in' }} style={styles.page}>
        <Image src="/free-resources/seven-signs-its-time/6.png" style={styles.background} />
      </Page>

      <Page size={{ width: '20in', height: '11.25in' }} style={styles.page}>
        <Image src="/free-resources/seven-signs-its-time/7.png" style={styles.background} />
      </Page>

      <Page size={{ width: '20in', height: '11.25in' }} style={styles.page}>
        <Image src="/free-resources/seven-signs-its-time/8.png" style={styles.background} />
      </Page>

      <Page size={{ width: '20in', height: '11.25in' }} style={styles.page}>
        <Image src="/free-resources/seven-signs-its-time/9.png" style={styles.background} />
      </Page>

      <Page size={{ width: '20in', height: '11.25in' }} style={styles.page}>
        <Image src="/free-resources/seven-signs-its-time/10.png" style={styles.background} />
      </Page>

      <Page size={{ width: '20in', height: '11.25in' }} style={styles.page}>
        <Image src="/free-resources/seven-signs-its-time/11.png" style={styles.background} />

        <AgentInfo userInfo={userInfo} />

        <Image
          src={teamOrCompanyLogoUrl}
          style={{
            ...styles.teamOrCompanyLogo,
            top: '1.2in',
            left: '1.48in',
            width: '2.4in',
            height: '2.0in',
          }}
        />
      </Page>
    </Document>
  );
};

export default SevenSignsDocument;
